import { ChangeEvent, useEffect, useState } from "react";
import CheckboxIcon from "./icons/Checkbox";
import CheckboxCheckedIcon from "./icons/CheckboxChecked";

type CheckboxProps = {
  className?: string;
  checked?: boolean;
  label?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const Checkbox = ({
  className,
  checked = false,
  label,
  onChange,
}: CheckboxProps) => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e);
    setIsChecked((prev) => !prev);
  };

  return (
    <label className={`flex items-center ${className}`}>
      <input
        type="checkbox"
        className="peer sr-only"
        checked={isChecked}
        onChange={handleChange}
      />
      {isChecked ? (
        <CheckboxCheckedIcon className="peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-blue-600" />
      ) : (
        <CheckboxIcon className="peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-blue-600" />
      )}
      <span
        className={`ml-2 hidden font-semibold medium:block ${
          isChecked ? "text-BG-55" : ""
        }`}
      >
        {label || "Select"}
      </span>
    </label>
  );
};
